export const licenseIsMobile = (license) => {
    switch (license) {
        case 'mobile':
            return true;
        case 'fixed':
            return false;
        case 'none':
            return false;
        case 'unknown':
            return false;
        default:
            return false;
    }
};

/**
 * Function to check if a user is a FlowFree user.
 * The criteria for a FlowFree user is:
 * - Customers productType is 'flow'
 * - The extension has no licence. e.g. Fixed, Mobile.
 *
 * @param customer
 * @param extension
 * @returns {*}
 */
export const isFlowFreeUser = (customer, extension) => {
    if (!customer || !extension) {
        return null;
    } else {
        return (
            customer.get('productType') === 'flow' && !extension.get('license')
        );
    }
};

export const isFlowFreeCustomer = (customer) => {
    if (!customer) {
        return null;
    } else {
        return (
            customer.get('productType') === 'flow' &&
            !customer.get('premiumCustomer')
        );
    }
};

const isWholesalePartnerCustomer = (customer) => {
    if (!customer) {
        return null;
    } else {
        return !!customer.get('isWholesaleCustomer');
    }
};

export const isFlowBrandedCustomer = (customer) => {
    if (!customer) {
        return null;
    }
    const retailerKey = customer.getIn(['retailer', 'key']);

    // Numintec counts as a wholesale retailer, but should not have the flow brand.
    if (retailerKey === 'retailer-781') {
        return false;
    }

    return (
        isWholesalePartnerCustomer(customer) ||
        isWhiteLabeledRetailer(retailerKey)
    );
};

export const isWhiteLabeledRetailer = (retailerKey) => {
    return [
        'retailer-676', // iCentrex AB
    ].includes(retailerKey);
};
